import { Component, input } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

/** Stripe's own "S" mark, `fill="currentColor"` so it inherits whatever text
 * colour the wrapping element sets. Home, Secure Trade, and checkout all
 * reuse this mark instead of a plain-text mention. */
const STRIPE_MARK_SVG =
  '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z"/></svg>';

/** Small "Powered by Stripe" mark + label, e.g. next to a checkout form or
 * in a trust strip. Colour is set by the caller (text-* utility on a
 * wrapping element or via `markClass`) since the mark itself just inherits
 * currentColor. */
@Component({
  selector: 'app-stripe-badge',
  standalone: true,
  template: `
    <span
      class="flex h-4 w-4 shrink-0 items-center justify-center"
      [class]="markClass()"
      [innerHTML]="mark"
    ></span>
    <span>{{ label() }}</span>
  `,
  host: { class: 'inline-flex items-center gap-1.5' },
})
export class StripeBadgeComponent {
  readonly label = input('Powered by Stripe');
  /** Colour utility for just the mark, when it needs to differ from the
   * surrounding text (e.g. brand blurple on a light card). */
  readonly markClass = input('');
  readonly mark: SafeHtml;

  constructor(sanitizer: DomSanitizer) {
    this.mark = sanitizer.bypassSecurityTrustHtml(STRIPE_MARK_SVG);
  }
}
